import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../utils/Hooks';
import { getCountries } from '../../store/reducers/CountriesSlice';

interface Country {
    id: number;
    name: string;
}

interface SettingsCountryPickerProps {
    value: number[];
    onChange: (countryIds: number[]) => void;
}

const SettingsCountryPicker: React.FC<SettingsCountryPickerProps> = ({ value, onChange }) => {
    const dispatch = useAppDispatch();
    const countriesState = useAppSelector(state => state.countries);
    const [selectedCountries, setSelectedCountries] = useState<number[]>(value);

    useEffect(() => {
        dispatch(getCountries());
    }, [dispatch]);

    useEffect(() => {
        setSelectedCountries(value);
    }, [value]);

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = Array.from(event.target.selectedOptions).map(option => parseInt(option.value));
        const newSelected = [...new Set([...selectedCountries, ...selectedOptions])];
        setSelectedCountries(newSelected);
        onChange(newSelected);
    };

    const handleRemoveCountry = (countryId: number) => {
        const newSelected = selectedCountries.filter(id => id !== countryId);
        setSelectedCountries(newSelected);
        onChange(newSelected);
    };

    const getCountryName = (id: number) => {
        const country = countriesState.countries.find(c => c.id === id);
        return country ? country.name : 'Unknown';
    };

    return (
        <div className="w-full">
            {selectedCountries.length > 0 && (
                <div className="selected-countries mb-2">
                    {selectedCountries.map(id => (
                        <span key={id} className="selected-country">
                            {getCountryName(id)}
                            <button
                                type="button"
                                onClick={() => handleRemoveCountry(id)}
                                className="remove-country"
                            >
                                ✕
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <select
                multiple
                value={selectedCountries.map(String)}
                onChange={handleSelectChange}
                className="text w-full p-2 border rounded"
            >
                {countriesState.countries.map(country => (
                    <option key={country.id} value={country.id}>
                        {country.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SettingsCountryPicker;